/* @flow */
import {
  SLIDESHOW_AD_CADENCE,
  SLIDESHOW_AD_OFFSET
} from './__constants__';
import getSectionAdList from './getSectionAdList';

import type {
  SectionAdListOptions,
  SectionAdListTuple
} from './__types__';

export default (
  options: SectionAdListOptions,
): SectionAdListTuple => {
  // This will increment as the loop in `getSectionAdList` calls
  // `didIncrementSection`.
  let sectionIndex = 1;

  return getSectionAdList(options, {

    canDisplayAd: (): bool =>
      (sectionIndex - SLIDESHOW_AD_OFFSET) % SLIDESHOW_AD_CADENCE === 0,

    didIncrementSection: (): void => {
      sectionIndex++;
    }

  });
};
